<template>
<div id="container"><!-- [D]left menu collapse : <div id="container" class="snb_collapsed"> -->
    <div class="container_wrap">
        <skp-snb></skp-snb>
        <!-- contents -->
        <div id="contents">

            <base-search-area
                :bToggle="false"
                :pKeyword="keyword"
                :topClass="'srchTop_wrap mainSrch_wrap'"
                :callSearchFunc="callSearchFunc"
            />

            <!-- category_wrap -->
            <div class="row no-margin-lr category_wrap">
                <div class="col-12">
                    <div class="service_block">
                        <!-- Category List -->
                        <div class="category_list">
                            <header><!-- 200709수정 - 타이틀추가 -->
                                <h3>Category</h3>
                            </header>
                            <ul class="depth1">
                                <li v-for="cate1 in allCategories" :key="cate1.code">
                                    <a href="javascript:" @click="clickCategory($event, cate1)" :title="cate1.codeDesc">{{cate1.codeDesc}}</a>
                                </li>
                            </ul>
                            <!-- 모바일 S -->
                            <div class="sub_list_warp">
                                <div v-if="secondCategories && secondCategories.length > 0" class="category_layer" style="display:block">
                                    <div class="sub_list">
                                        <dl class="sub_list_item scroll"><!-- 2depth -->
                                            <dd>
                                                <ul>
                                                    <li v-for="cate2 in secondCategories" :key="cate2.code">
                                                        <a href="javascript:" @click="clickCategory($event, selCate1, cate2)">{{cate2.codeDesc}}</a>
                                                    </li>
                                                </ul>
                                            </dd>
                                        </dl>
                                        <dl class="sub_list_item scroll"><!-- 3depth -->
                                            <dd>
                                                <ul>
                                                    <li v-for="cate3 in thirdCategories" :key="cate3.code">
                                                        <a href="javascript:" @click="clickCategory($event, selCate1, selCate2, cate3)">{{cate3.codeDesc}}</a>
                                                    </li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>

<!--                            <ul class="depth1">
                                <li v-for="cate1 in allCategories" :key="cate1.code">
                                    <a href="javascript:" @click="clickCategory($event, cate1)" :title="cate1.codeDesc">{{cate1.codeDesc}}</a>
                                    <ul class="depth2">
                                        <li v-for="cate2 in cate1.subList" :key="cate2.code" @click="clickCategory($event, cate1, cate2)">
                                            <a href="javascript:">{{cate2.codeDesc}}</a>
                                            <ul v-if="cate2.subList && cate2.subList.length > 0" class="depth3">
                                                <li v-for="cate3 in cate2.subList" :key="cate3.code" @click="clickCategory($event, cate1, cate2, cate3)">
                                                    <a href="javascript:">{{cate3.codeDesc}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
-->
                            <!-- For Mobile Only -->
                            <div class="sub_list_warp">
                                <section v-for="cate1 in allCategories" :key="cate1.code">
                                    <p class="category_tit">{{cate1.codeDesc}}</p>
                                    <div class="sub_list">
                                        <dl v-for="cate2 in cate1.subList" :key="cate2.code" class="sub_list_item">
                                            <dt>{{cate2.codeDesc}}</dt>
                                            <dd>
                                                <ul>
                                                    <li v-for="cate3 in cate2.subList" :key="cate3.code">
                                                        <a href="javascript:" @click="clickCategory(cate1, cate2, cate3)">{{cate3.codeDesc}}</a>
                                                    </li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </div>
                                </section>
                            </div>
                        </div>

                        <!-- Recent Content -->
                        <div class="recent_wrap accordion_wrap toggle_close">
                            <header>
                                <h3>{{$t('TITLE.SEARCH.RECENT.CONTENT')}}</h3>
                            </header>
                            <ul class="ul_list">
                                <li v-for="cont in recentContents" :key="cont.TITLE">
                                    <a href="javascript:" @click="clickContent(cont)">{{cont.CATEGORY_NM}} <b>{{cont.TITLE}}</b></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //category_wrap -->

            <div v-if="isContentsLoading" class="row mainBtm_box">
                <div class="row_no_margin">
                    <div class="nodata">
                        <!-- 200708수정(loading) S -->
                        <span class="loader_box">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </span>
                        <!-- 200708수정(loading) E -->
                    </div>
                </div>
            </div>
            <div class="row mainBtm_box">
                <div class="col-4 col-md-12 col-sm-12 tab_content" v-for="(cont, idx) in myContentsList">
                    <!-- TODO 20.06.10 ASC Contents config button 퍼블리싱 나오면 교체 필요 -->
                    <a v-if="idx === (myContentsList.length - 1)" href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnContentsConfig">
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
                    </a>
                    <!-- // TODO END -->
                    <div class="service_block accordion_wrap toggle_close">
                        <header>
                            <h3 v-if="cont.WORK_KEY === 'H'" :rel="idx+2" @click="contentsReload($event, cont.WORK_KEY)">{{ $t('FIELD.DASHBOARD.HOT.CONTENTS') }}</h3>
                            <h3 v-if="cont.WORK_KEY === 'F'" :rel="idx+2" @click="contentsReload($event, cont.WORK_KEY)">{{ $t('FIELD.DASHBOARD.FAVORITE.CONTENT') }}</h3>
                            <h3 v-if="cont.WORK_KEY === 'N'" :rel="idx+2" @click="contentsReload($event, cont.WORK_KEY)">{{ $t('FIELD.DASHBOARD.NEW.UPDATE') }}</h3>
                            <h3 v-if="cont.WORK_KEY === 'S'" :rel="idx+2" @click="contentsReload($event, cont.WORK_KEY)">{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</h3>
                        </header>
                        <template v-if="!hotReady && cont.WORK_KEY === 'H'">
                            <ul class="ul_list">
                                <li class="nodata">
                                    <!-- 200708수정(loading) S -->
                                    <span class="loader_box">
                                        <div class="loader"><span class="sr_only">Loading...</span></div>
                                    </span>
                                    <!-- 200708수정(loading) E -->
                                </li>
                            </ul>
                        </template>
                        <template v-if="hotReady && cont.WORK_KEY === 'H'">
                            <ul v-if="hotContentsList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in hotContentsList">
                                    <span class="subject">
                                        <a href="javascript:" @click="contentsPopup(content)">
                                            <em v-if="content.HOT_TYPE === 'R'" class="textbgbox_recommend">R</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <em v-if="content.HOT_TYPE === 'R'" class="textbgbox_recommend">R</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                        </template>
                        <template v-if="!favReady && cont.WORK_KEY === 'F'">
                            <ul class="ul_list">
                                <li class="nodata">
                                    <!-- 200708수정(loading) S -->
                                    <span class="loader_box">
                                        <div class="loader"><span class="sr_only">Loading...</span></div>
                                    </span>
                                    <!-- 200708수정(loading) E -->
                                </li>
                            </ul>
                        </template>
                        <template v-if="favReady && cont.WORK_KEY === 'F'">
                            <ul v-if="favoriteList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in favoriteList">
                                    <span class="subject">
                                        <a href="javascript:" @click="contentsPopup(content)">
                                            <!--
                                            <em class="textbox_fix">Fix</em>
                                            <em class="textbox_rejected">Rejected</em>
                                            <em class="textbox_processing">Processing</em>
                                            <em class="textbox_complete">Complete</em>
                                            <em class="textbox_canceled">Canceled</em>
                                            <em v-if="content.TYPE === 1 && content.SHARE_ID !== undefined" class="textbox_request">{{ $t('FIELD.GLOBAL.REQUEST.SHARING') }}</em>
                                            <em v-else-if="content.TYPE === 1 && content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.TYPE === 1 && content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            <em v-else-if="content.TYPE === 2" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            <em v-else-if="content.TYPE === 3" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            -->
                                            <em v-if="content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <!--
                                            <em class="textbox_fix">Fix</em>
                                            <em class="textbox_rejected">Rejected</em>
                                            <em class="textbox_processing">Processing</em>
                                            <em class="textbox_complete">Complete</em>
                                            <em class="textbox_canceled">Canceled</em>
                                            <em v-if="content.TYPE === 1 && content.SHARE_ID !== undefined" class="textbox_request">{{ $t('FIELD.GLOBAL.REQUEST.SHARING') }}</em>
                                            <em v-else-if="content.TYPE === 1 && content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.TYPE === 1 && content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            <em v-else-if="content.TYPE === 2" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            <em v-else-if="content.TYPE === 3" class="textcolor_todo">[{{ $t('FIELD.GLOBAL.TO.DO') }}]</em>
                                            -->
                                            <em v-if="content.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                            <em v-else-if="content.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                        </template>
                        <template v-if="!newReady && cont.WORK_KEY === 'N'">
                            <ul class="ul_list">
                                <li class="nodata">
                                    <!-- 200708수정(loading) S -->
                                    <span class="loader_box">
                                        <div class="loader"><span class="sr_only">Loading...</span></div>
                                    </span>
                                    <!-- 200708수정(loading) E -->
                                </li>
                            </ul>
                        </template>
                        <template v-if="newReady && cont.WORK_KEY === 'N'">
                            <ul v-if="newUpdateList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in newUpdateList">
                                    <span class="subject">
                                        <a href="javascript:" @click="contentsPopup(content)">
                                            <em v-if="content.ICO_TYPE === 'U'" class="textbgbox_update">U</em>
                                            <em v-else-if="content.ICO_TYPE === 'N'" class="textbgbox_new">N</em>
                                            {{ content.KNOWLEDGE_TITLE | decodeXSS }}
                                        </a>
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                        </template>
                        <template v-if="!supReady && cont.WORK_KEY === 'S'">
                            <ul class="ul_list">
                                <li class="nodata">
                                    <!-- 200708수정(loading) S -->
                                    <span class="loader_box">
                                        <div class="loader"><span class="sr_only">Loading...</span></div>
                                    </span>
                                    <!-- 200708수정(loading) E -->
                                </li>
                            </ul>
                        </template>
                        <template v-if="supReady && cont.WORK_KEY === 'S'">
                            <ul v-if="supportList.length === 0" class="ul_list">
                                <li class="nodata">
                                    <span>
                                        {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                                    </span>
                                </li>
                            </ul>
                            <ul v-else class="ul_list">
                                <li v-for="(content, idx) in supportList">
                                    <span class="subject">
                                        <a href="javascript:" @click="popSupport(content.KEY, content.KEY_TYPE)">
                                            <em v-if="content.STATUS === 'Replied'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Inquiry'" class="textcolor_check">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Warning'" class="textcolor_warning">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Answered'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Commented'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            {{ content.TITLE | decodeXSS }}
                                        </a>
                                        <i class="tooltip_m">
                                            <em v-if="content.STATUS === 'Replied'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Inquiry'" class="textcolor_check">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Warning'" class="textcolor_warning">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Answered'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            <em v-else-if="content.STATUS === 'Commented'" class="textcolor_replied">[{{ content.STATUS }}]</em>
                                            {{ content.TITLE | decodeXSS }}
                                        </i><!-- 200423수정-->
                                    </span>
                                    <span class="date">{{ content.REG_DT }}</span>
                                </li>
                            </ul>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- contents -->
    </div>
</div>
</template>
<script>
import Vue                          from 'vue';
import qs                           from 'query-string';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import { SDLUtil, StringUtil }      from '@/utils';
import { mapActions, mapGetters }   from 'vuex';
import { EventBus }                 from '@/utils/EventBus';

import SKPSnb                       from '~vb/main/SKPSnb';
import KnowlDetlPopup               from '~vb/knowledge/popup/KnowledgeDetailPopup';
import SearchArea                   from '~vb/intgSearch/SearchArea';

import ContentsConfigPopup          from '~vb/dashboard/popup/ContentsConfigPopup';
import answerDetailPopup            from '~vb/faq/popup/answerDetailPopup';
import questionDetailPopup          from '~vb/faq/popup/questionDetailPopup';
import communicationPopup           from '~vb/faq/popup/communicationPopup';
import viewFaqPopup                 from '~vb/faq/popup/viewFaqPopup';

import BulletinViewPopup from '~vb/anysvcmobile/svcBulletin/BulletinViewPopup';

/*
 * ASC Tab 구현 시 my Setting Contents 확인 필요
 * - ASC 의 경우에는 설정에 따라 탭이 감춰져서 나오는 경우가 있음
 *   - 내 설정에 따라 탭이 감춰지고 보여지는 유동적인 탭 설계가 필요
 */
const fetchMySetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/main/getMySetting.skp`,
    qs.stringify({ workType: workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const fetchContentsList = params => axios.post(
    `${SDLUtil.API_URL}/basis/main/listDashboardContents.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
	name: 'ASCSearchPage',
    props: {
//        rtnSearchFunc: { type: Function }
    },
	data() {
		return {
            keyword: '',
            searchMode: '1', // '1':recentModels, '2':autoCompletes, '3':detailSearch
            searchKind: 'C', // 'C':Code, 'N':Name, 'K':keyword
            autoCompletes: [],
            recentModels: [],
            recentContents: [],
            allCategories: [],
            secondCategories: [],
            thirdCategories: [],
            selCate1: {},
            selCate2: {},
            cursorIndex: -1,

            isContentsLoading: true,
            myContentsList: [],     // mySetting by CONTENT, default: ['H', 'F', 'N']

            hotContentsLoad: false,
            hotContentsList: [],
            favoriteLoad: false,
            favoriteList: [],
            newUpdateLoad: false,
            newUpdateList: [],
            supportLoad: false,
            supportList: [],

            hotReady: false,
            favReady: false,
            newReady: false,
            supReady: false,

		}
	},
    computed: {
        isContentsFold() {
            return !(this.hotContentsLoad && this.favoriteLoad && this.newUpdateLoad && this.supportLoad);
        }
    },
    components : {
        'base-search-area'  : SearchArea,
        'skp-snb'   : SKPSnb
    },
    methods: {
        async init(mode) {
            const param = {};
            let url = `${SDLUtil.API_URL}/basis/search/getRecentModels.skp`;
            if (mode == 2) url = `${SDLUtil.API_URL}/basis/search/getRecentContents.skp`;
            else if (mode == 3) url = `${SDLUtil.API_URL}/basis/search/getAllCategories.skp`;
            return await axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    if (mode == 1) { // 최근검색어
                        this.recentModels   = resp.data;
                        console.log('recentModels ==> ', resp.data);
                    } else if (mode == 2) { // 최근 컨텐츠
                        this.recentContents = resp.data;
                        console.log('RecentContents ==> ', resp.data);
                    } else if (mode == 3) { // 모든 카테고리
                        this.allCategories = resp.data;
                        console.log('allCategories ==> ', resp.data);
                        this.$nextTick(function() {
                            this.applyEvent();
                        });
                        SDLUtil.showLoadingBar(false);
                    }
                })
                .catch(err => {
                    console.log('Error.init ======> ', err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        callSearchFunc(param) {
            if (param.keyword.length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                return true;
            }
            if (param.screenMode == 'D') {
                let frDate = SDLUtil.convertDate(param.FRDT).replace(/-/g, '');
                let toDate = SDLUtil.convertDate(param.TODT).replace(/-/g, '');
                if (Number(toDate) < Number(frDate)) {
                    SDLUtil.alert('MESSAGE.DATE.VALIDATION.START.END');
                    return true;
                }
            }

            // 통합검색 페이지로 이동
            param.screenMode = 'B';
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/SearchList`;
            this.$router.push({ path: pathUrl, query: param });
        },
        clickContent(contentObj) {
            SDLUtil.show(
                KnowlDetlPopup,
                {
                    KNOWLEDGE_ID: contentObj.KNOWLEDGE_ID,
                    BOARD_ID: contentObj.BOARD_ID,
                    rtnFunc: () => {
                        // callback function event
                    }
                },
                { height: 'auto' }
            );
        },
        popSupport(key, type) {
            let option = { width: '500px', height: 'auto' };
            let params = {
                searchKey: key,
                rtnFunc: () => {
                    this.getContentList({ contType: 'S' }).then(res => {
                        let data = res.data;
                        if (data.contentsList.rowCount > 0) {
                            this.supportList = data.contentsList.rowData;
                        }
                    });
                },
            };

            if ('QA' === type) {
                SDLUtil.show(questionDetailPopup, params, option);
            } else if ('QP' === type) {
                let param = key.split('^');
                SDLUtil.show(communicationPopup, { param: { questionId: param[0], questionFlowId: param[1] } }, option);
            } else if ('A' === type) {
                SDLUtil.show(answerDetailPopup, params, option);
            } else if ('F' === type) {
                SDLUtil.show(viewFaqPopup, params, option);
            }
        },
        applyEvent() {
            //category list
            $('.category_list .depth1 > li').on("mouseleave",function(){
//                $(this).removeClass('active');
            });

            $('.category_list .depth2 > li').mouseover(function() {
                $(this).addClass('active');
            });

            $('.category_list .depth2 > li').on("mouseleave",function(){
                $(this).removeClass('active');
            });

            //accordion
            $('.accordion_wrap header').click(function() {
                if( $(this).closest("div").hasClass('toggle_close') == true){
                    $(this).closest("div").removeClass('toggle_close');
                } else {
                    $(this).closest("div").addClass('toggle_close');
                }
            });

            //mobile - category
            $('.category_tit').click(function(){
                if( $(this).closest("section").hasClass('toggle_open') == true){
                    $(this).closest("section").removeClass('toggle_open');
                } else {
                    $(this).closest("section").addClass('toggle_open');
                }
            });

            $('.sub_list_item dt').click(function(){
                if( $(this).closest("dl").hasClass('toggle_open') == true){
                    $(this).closest("dl").removeClass('toggle_open');
                } else {
                    $(this).closest("dl").addClass('toggle_open');
                }
            });
        },
        // 카테고리 클릭 시...
        clickCategoryOld(event, cate1, cate2, cate3) {
            if (!cate2) { // 1-Depth 클릭 시...
                let pli = $(event.target).parent('li');
                if (pli.hasClass('active')) {
                    pli.removeClass('active');
                } else {
                    pli.addClass('active');
                }
            } else { // 2/3-Depth 클릭 시...
                let param = {prodCateCd1: cate1.code, prodCateCd2: cate2.code};
                if (cate3) {
                    param.prodCateCd3 = cate3.code;
                } else { // 2번째 클릭 시..
                    if (cate2.subList && cate2.subList.length > 0) return;
                }

                let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/SearchAscList`;
                this.$router.push({ path: pathUrl, query: param });
            }
        },
        // 카테고리 클릭 시...
        clickCategory(event, cate1, cate2, cate3) {
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/SearchAscList`;
            $(event.target).parent('li').parent('ul').children('li').removeClass('active');
            $(event.target).parent('li').addClass('active');
            if (!cate2) { // 1-Depth 클릭 시...
                this.selCate1 = cate1;
                this.secondCategories = cate1.subList;
                this.thirdCategories = [];
            } else if (!cate3) { // 2-Depth 클릭 시...
                this.selCate2 = cate2;
                this.thirdCategories = cate2.subList;
                let param = {prodCateCd1: this.selCate1.code, prodCateCd2: cate2.code};
                if (!cate2.subList || cate2.subList.length == 0) {
                    this.$router.push({ path: pathUrl, query: param });
                }
            } else { // 3-Depth 클릭 시..
                let param = {prodCateCd1: this.selCate1.code, prodCateCd2: this.selCate2.code, prodCateCd3: cate3.code};
                this.$router.push({ path: pathUrl, query: param });
            }
        },
        initBottomContents() {
            SDLUtil.showLoadingBar(true);
            this.mySettingList("ASC_CONT").then( res => {
                let data = res.data;
                if(data.mySetting.rowCount > 0){
                    this.myContentsList = data.mySetting.rowData;
                };

                this.$nextTick(() => {
                    this.isContentsLoading = false;
                    SDLUtil.showLoadingBar(false);
                });
            });
        },
        async mySettingList(workType) {
            return await fetchMySetting(workType);
        },
        async getContentList(contType) {
            return await fetchContentsList(contType);
        },
        toastPopup(msg) {
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },

        // Sidebar 에서 카테고리 선택 후 카테고리 적용하여 컨텐츠 목록 재조회
        setCategory(v) {
            let params = {
                PRD_CATEGORY_CD1: v.searchPRD_CATEGORY_CD1 || '',
                PRD_CATEGORY_CD2: v.searchPRD_CATEGORY_CD2 || '',
                PRD_CATEGORY_CD3: v.searchPRD_CATEGORY_CD3 || ''
            };
            console.log(v);
            this.allContentReload(params);
        },
        // 컨텐츠 설정 팝업
        btnContentsConfig() {
            SDLUtil.show(
                ContentsConfigPopup,
                {
                    ascContList: this.myContentsList,
                    rtnFunc: list => {
                        if(list.length > 0) {
                            $('div.service_block').addClass('toggle_close');
                            this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                            this.$nextTick( () => {
                                this.myContentsList = list;
                                this.hotContentsLoad = false;
                                this.favoriteLoad = false;
                                this.newUpdateLoad = false;
                                this.supportLoad = false;
                            });
                        };
                    }
                },
                { height: 'auto' }
            );
        },
        async allContentReload(params = {}) {
            // 아무것도 로드 되어 있지 않다면 undo 버튼은 다시 리셋
            if(!this.hotContentsLoad && !this.favoriteLoad && !this.newUpdateLoad && !this.supportLoad) {
                this.$nextTick(() => { EventBus.$emit('main-snb-undo-reset'); });

            } else {
                if(this.hotContentsLoad) {
                    this.hotReady = false;
                    Object.assign(params, { contType: 'H' })
                    await this.getContentList(params).then( res => {
                        let data = res.data;
                        this.hotContentsList = data.contentsList.rowData;
                        this.hotReady = true;
                    });
                };

                if(this.favoriteLoad) {
                    this.favReady = false;
                    Object.assign(params, { contType: 'F' })
                    await this.getContentList(params).then( res => {
                        let data = res.data;
                        this.favoriteList = data.contentsList.rowData;
                        this.favReady = true;
                    });
                };

                if(this.newUpdateLoad) {
                    this.newReady = false;
                    Object.assign(params, { contType: 'N' })
                    await this.getContentList(params).then( res => {
                        let data = res.data;
                        this.newUpdateList = data.contentsList.rowData;
                        this.newReady = true;
                    });
                };

                if(this.supportLoad) {
                    this.supReady = false;
                    Object.assign(params, { contType: 'S' })
                    await this.getContentList(params).then( res => {
                        let data = res.data;
                        this.supportList = data.contentsList.rowData;
                        this.supReady = true;
                    });
                };

            };
        },
        contentsReload(e, workKey) {
            let hasClass = $(e.target).parents('div.service_block').hasClass('toggle_close');
            // HOT Contents
            if(workKey === 'H'){
                if(hasClass) {
                    this.hotReady = false;
                    this.getContentList({ contType: workKey }).then( res => {
                        let data = res.data;
                        this.hotContentsList = data.contentsList.rowData;
                        this.hotContentsLoad = true;
                        this.hotReady = true;
                    });

                } else {
                    this.hotContentsLoad = false;
                    this.hotReady = false;
                }

            // Favorite Contents
            } else if(workKey === 'F'){
                if(hasClass) {
                    this.favReady = false;
                    this.getContentList({ contType: workKey }).then( res => {
                        let data = res.data;
                        this.favoriteList = data.contentsList.rowData;
                        this.favoriteLoad = true;
                        this.favReady = true;
                    });

                } else {
                    this.favoriteLoad = false;
                    this.favReady = false;
                }

            // New & Update
            } else if(workKey === 'N'){
                if(hasClass) {
                    this.newReady = false;
                    this.getContentList({ contType: workKey }).then( res => {
                        let data = res.data;
                        this.newUpdateList = data.contentsList.rowData;
                        this.newUpdateLoad = true;
                        this.newReady = true;
                    });

                } else {
                    this.newUpdateLoad = false;
                    this.newReady = false;
                }

            // Support
            } else if(workKey === 'S'){
                if(hasClass) {
                    this.supReady = false;
                    this.getContentList({ contType: workKey }).then( res => {
                        let data = res.data;
                        this.supportList = data.contentsList.rowData;
                        this.supportLoad = true;
                        this.supReady = true;
                    });

                } else {
                    this.supportLoad = false;
                    this.supReady = false;
                }
            };

            if(hasClass) {
                EventBus.$emit('main-snb-undo-reset');
            };
        },
        contentsPopup(contentObj) {
            let hhpYn = StringUtil.strToBool(contentObj.HHP_YN);
            if(!hhpYn) {
                //Knowledge Detail 실행
                SDLUtil.show(
                    KnowlDetlPopup,
                    {
                        KNOWLEDGE_ID: contentObj.KNOWLEDGE_ID,
                        BOARD_ID: contentObj.BOARD_ID,
                        rtnFunc: () => {
                            // callback function event
                            this.allContentReload();
                        }
                    },
                    { height: 'auto' }
                );
            } else {
                SDLUtil.show(
                    BulletinViewPopup,
                    {
                        seq: contentObj.KNOWLEDGE_ID,
                        rtnFunc: () => {
                            // callback function event
                            this.allContentReload();
                        }
                    },
                    { height: 'auto' }
                );
            }
        }
    },
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
        keyword() {
        }
    },
    created() {
        // Snb Event
        EventBus.$on('quick-category', v => { this.setCategory(v); });
        localStorage.setItem('search.keyword',     '');
        localStorage.setItem('search.screenMode', 'B');
        localStorage.setItem('search.searchMode', '1');
        localStorage.setItem('search.searchKind', 'C');
        this.initBottomContents();
    },
    mounted() {
        SDLUtil.showLoadingBar(true);
        this.init(2); // 최근컨텐츠
        this.init(3); // 모든 카테고리
//        this.applyEvent();
//        this.$refs.kword.focus();
    },
    beforeDestroy() {
        EventBus.$off('quick-category');
    },
};
</script>
<style scoped>
.mainBtm_box .ul_list li.nodata > span {display:table-cell;height:400px;vertical-align:middle;font-size:14px;font-weight:bold;}
.mainBtm_box .ul_list li.nodata > span img {vertical-align:middle;margin-right:20px;}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/SearchPage.vue